import {
  PARTICIPANTE_STATUS,
  PERFIL_LIDERANCA,
  PARTICIPANTES_FILTRO_MAX_LIMIT,
} from './constants';

export const createEmptyFiltro = () => ({
  tempoCargoDias: null,
  tempoEmpresaDias: null,
  perfilLideranca: PERFIL_LIDERANCA.TODOS,
  cargos: [],
  areas: [],
  considerarAreasSubordinadas: false,
  colaboradoresGrupos: [],
});

const getFieldNome = (value) => {
  if (!value) return undefined;

  if (typeof value === 'string') return value;

  return value.nome ?? value.Nome ?? value.descricao ?? value.Descricao;
};

export const getAreaNome = (item) =>
  getFieldNome(item?.area ?? item?.unidadeArea);

export const getCargoNome = (item) =>
  getFieldNome(item?.cargo ?? item?.unidadeCargo);

export const normalizeColaborador = (item) => {
  if (!item) return null;

  const areaNome = getAreaNome(item);
  const cargoNome = getCargoNome(item);

  return {
    ...item,
    id: item.id ?? item.Id,
    nome: item.nome ?? item.Nome,
    area: item.area ?? item.Area ?? (areaNome ? { nome: areaNome } : null),
    cargo: item.cargo ?? item.Cargo ?? (cargoNome ? { nome: cargoNome } : null),
    unidadeArea: areaNome,
    unidadeCargo: cargoNome,
    fotoArquivo: item.fotoArquivo ?? item.FotoArquivo,
  };
};

export const normalizeParticipantesResponse = (
  data,
  statusSalvamento = PARTICIPANTE_STATUS.SALVO
) => {
  const items =
    data?.list || data?.participantes || data?.colaboradores || data || [];

  if (!Array.isArray(items)) return [];

  return items
    .map(normalizeColaborador)
    .filter((item) => item?.id)
    .map((item) => ({
      ...item,
      statusSalvamento,
    }));
};

export const getParticipantesResponseCount = (data, fallbackCount) =>
  data?.count ?? data?.total ?? data?.totalCount ?? fallbackCount;

export const limitParticipantesPorFiltro = (participantes = []) =>
  participantes.slice(0, PARTICIPANTES_FILTRO_MAX_LIMIT);

export const normalizeFiltroSearch = (value = '') =>
  value
    .toString()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase();

export const splitColaboradoresGrupos = (items = []) => ({
  colaboradores: items
    .filter((item) => item.identificadorLista !== 'grupos')
    .map((item) => ({ id: item.id })),
  grupos: items
    .filter((item) => item.identificadorLista === 'grupos')
    .map((item) => ({ id: item.id })),
});

export const mergeParticipantes = (currentItems = [], newItems = []) => {
  const map = new Map();

  [...currentItems, ...newItems].forEach((item) => {
    const colaborador = normalizeColaborador(item);
    if (colaborador?.id && !map.has(colaborador.id)) {
      map.set(colaborador.id, colaborador);
    }
  });

  return Array.from(map.values());
};
